// src/redux/productsSubitems/slice.ts
import { createSlice } from '@reduxjs/toolkit';
import { SubItemsState } from './types';
import { fetchProductSubitems } from './thunk';
import type { RootState } from '@/redux/store'; // adjust to your store path

const initialState: SubItemsState = {
  items: [],
  loading: false,
  error: null,
  lastItemId: null,
};

const subitemsSlice = createSlice({
  name: 'products/subitems',
  initialState,
  reducers: {
    resetSubitems(state) {
      state.items = [];
      state.loading = false;
      state.error = null;
      state.lastItemId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductSubitems.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        // Peek the item_id from meta.arg for debugging/memoization if needed
        state.lastItemId = action.meta.arg?.item_id ?? null;
      })
      .addCase(fetchProductSubitems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload ?? [];
      })
      .addCase(fetchProductSubitems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to load subitems';
      });
  },
});

export const { resetSubitems } = subitemsSlice.actions;
export default subitemsSlice.reducer;

// Selectors
export const selectSubitems = (s: RootState) => s.productsSubitems.items;
export const selectSubitemsLoading = (s: RootState) =>
  s.productsSubitems.loading;
export const selectSubitemsError = (s: RootState) => s.productsSubitems.error;
export const selectLastQueriedItemId = (s: RootState) =>
  s.productsSubitems.lastItemId;
